import React from 'react';
import LightBoxGallery from '../components/PhotoGallery/LightBoxGallery';
// 有些共用全域型的元件、或者需要 DOM Node 的元件 root element 就掛在這裡
const CommonReference = () => {
  return (
    <React.Fragment>
      <div id="toast"></div>
      <div id="modal"></div>
      <LightBoxGallery />
    </React.Fragment>
  );
};
export default CommonReference;
